class ImageGridItem extends HTMLElement {
	constructor() {
		super();
		
		this.addEventListener('mouseenter', e => {
			const video = this.querySelector('video');
			if (video && window.innerWidth > 992) {
				video.play();
				this.classList.add('played');
			}
		});

		this.addEventListener('mouseleave', e => {
			const video = this.querySelector('video');
			if (video && window.innerWidth > 992) {
				video.pause();
			}
		});
	}
}

customElements.define('image-grid-item', ImageGridItem);